import type { FloatingSupportMenuProps } from './FloatingSupportMenu.types'
import LoggedInSupportFab from './LoggedInSupportFab'
import LoggedOutSupportMenu from './LoggedOutSupportMenu'

/**
 * Floating support trigger. Orchestrates which fab renders based on auth state — the two
 * behaviors are different enough (single action vs. a dropdown menu) to live in their own
 * components:
 *
 * - Logged in → `LoggedInSupportFab`: click calls `onLoggedInClick` directly, no dropdown.
 *   Omitting `onLoggedInClick` renders nothing.
 * - Logged out → `LoggedOutSupportMenu`: click toggles a dropdown built from `items`.
 *   An empty `items` array renders nothing.
 *
 * Portal-local for now — see FloatingSupportMenu.module.scss for why.
 */
function FloatingSupportMenu(props: FloatingSupportMenuProps) {
  const { isLoggedIn, onLoggedInClick, items, triggerIcon, triggerLabel, hidden, onOpenChange } = props

  if (hidden) return null

  if (isLoggedIn) {
    if (!onLoggedInClick) return null

    return <LoggedInSupportFab onClick={onLoggedInClick} triggerIcon={triggerIcon} triggerLabel={triggerLabel} />
  }

  return (
    <LoggedOutSupportMenu
      items={items}
      triggerIcon={triggerIcon}
      triggerLabel={triggerLabel}
      onOpenChange={onOpenChange}
    />
  )
}

export default FloatingSupportMenu
